import {useEffect} from "react";
import {useAuthenticatedSessionSnapshot} from "UserProvider";
import {endKeptUploadsPastSaving, keptUploadsOwnerOf} from "./forgetKeptUploads";

/**
 * Ends the unfinished uploads this browser kept that are past saving, on every page the composer is not on
 * (kitecorp/transferify-ui#3204), so they go the next time Transferify opens in this browser, as the Cookie Policy
 * says. The composer ends them itself, and says so once (`useResumableUpload`). The rule is
 * `endKeptUploadsPastSaving`; this only says when to ask.
 *
 * @param composerMounted whether the composer is on this page, which then does it itself
 */
export function useKeptUploadsSweep(composerMounted: boolean): void {
	const [session] = useAuthenticatedSessionSnapshot();
	const owner = keptUploadsOwnerOf(session);
	useEffect(() => {
		if (owner === undefined || composerMounted) {
			return;
		}
		void endKeptUploadsPastSaving(owner);
	}, [owner, composerMounted]);
}
